<template lang="html">
  <carousel :auto="0" :watch-items="post" :dots="true" :next-html="next" :prev-html="prev">
    <carousel-item v-for="(item, index) in post" :key="index">
      <item-media :post="item"/>
    </carousel-item>
  </carousel>
</template>

<script>
import { Carousel, CarouselItem } from 'vue-l-carousel';
import ItemMedia from './ItemMedia.vue';

export default {
  name: 'children-media',
  components: {
    Carousel,
    ItemMedia,
    CarouselItem,
  },
  props: {
    post: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      next: '<i class="fas fa-chevron-circle-right"></i>',
      prev: '<i class="fas fa-chevron-circle-left"></i>',
    };
  },
  computed: {},
  methods: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>

.v-carousel {
  width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
}

/deep/ .v-carousel {
  &-items {
    overflow-x: hidden;
    overflow-y: visible;
  }
  &-dots {
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    text-align: center;
  }
  &-dot {
    cursor: pointer;
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 0 5px;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.5);
  }
  &-dot.active {
    background: #000;
    cursor: default;
  }
  &-nav {
    cursor: pointer;
    position: absolute;
    line-height: 30px;
    font-size: 18px;
    color: rgba(255, 255, 255, 0.7);
    top: 50%;
    margin-top: -15px;
  }
  &-nav.prev {
    left: 20px;
  }
  &-nav.next {
    right: 20px;
  }

  &-item {
    width: 100%;
    float: left;
  }
}
</style>
